import {
  runBulk,
  type BulkAction,
} from "@/components/molecules/tables/bulk-actions";
import { useHasRole } from "@/features/clients/hooks/use-has-role";
import { useDeleteForm } from "@/features/qualifications/hooks/use-qualification-forms";
import type { QualificationForm } from "@/features/qualifications/types";
import { TrashIcon } from "@phosphor-icons/react";
import { useMemo } from "react";
import { useTranslation } from "@/features/utils/i18n";

export const useFormsBulkActions = (): BulkAction<QualificationForm>[] => {
  const { t } = useTranslation("qualifications");
  const isOwner = useHasRole("OWNER");
  const deleteForm = useDeleteForm();

  return useMemo(() => {
    if (!isOwner) return [];

    return [
      {
        key: "delete",
        label: t("forms.actions.delete"),
        icon: <TrashIcon className="h-4 w-4" />,
        variant: "destructive",
        confirm: (rows) =>
          t("forms.messages.bulkDeleteConfirm", { count: rows.length }),
        onAction: async (rows) => {
          await runBulk(rows, (form) => deleteForm.mutateAsync(form.id), {
            success: (count) => t("forms.messages.bulkDeleted", { count }),
            error: (count) => t("forms.messages.bulkDeleteError", { count }),
          });
        },
      },
    ];
  }, [isOwner, deleteForm, t]);
};
